import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
require("@src/_common/permission"); // 权限控制
import permissionMixins from "@src/_common/mixins/permission"; // 权限比较
import userModel from "@src/_common/mixins/userModel";
import * as mUtils from "@/common/js/mUtils";
import config from "@/config/index";
import * as API from "@/api/index";
import filters from "./filters/index";
import AES from "@src/_common/utils/secret";
import jsBridge from "@/common/js/appBridge";
require("@/plugins/ui-components-lib");
import "@/common/styles/index.scss"; // 自定义 css
import $bus from "@/eventBus/bus";
// v - console;
// import VConsole from "vconsole";
// const vConsole = new VConsole();
// Vue.use(vConsole);
/**
 * 引入公共方法mUtils
 */
Vue.prototype.$mUtils = mUtils;
Vue.prototype.$api = API;
Vue.prototype.$API = API;
Vue.prototype.AES = AES;
Vue.prototype.$jsBridge = jsBridge;
Vue.prototype.$bus = $bus;
/**
 * 公共配置信息
 */
Vue.prototype.$config = config;

// 注册全局过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

Vue.prototype.$authorityComparison = mUtils.authorityComparison;

// 全局注册mixins
Vue.mixin(userModel); // 公共mixins
Vue.mixin(permissionMixins); // 公共mixins
// 登录后跳转方法
Vue.prototype.goBeforeLoginUrl = (urls) => {
  let url = mUtils.Cookie.get("beforeLoginUrl");
  url = decodeURIComponent(url);
  if (!url || url.indexOf("/author") != -1) {
    if (urls) {
      router.replace(`/${urls}?type=123`);
    } else {
      router.replace("/");
    }
  } else {
    router.replace(url);
    mUtils.Cookie.set(
      "beforeLoginUrl",
      "",
      1 / 24 / 60,
      window.location.host,
      window.location.pathname.substring(0, window.location.pathname.length - 1)
    );
  }
};

String.prototype.replaceAll = function(s1, s2) {
  return this.replace(new RegExp(s1, "gm"), s2);
};

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
